import { useEffect, useMemo, useState } from 'react'
import { api } from '@/api'
import type { PricePreviewRequest, PricePreviewResponse } from '@/api/types'

/**
 * 报价预览。用户改任何一个会影响价格的参数（模型 / 数量 / 分辨率）就重新问一次后端，
 * 金额实时显示在按钮上方，避免「点下去才知道多少钱」。
 */
export function usePricePreview(params: PricePreviewRequest): PricePreviewResponse | null {
  const key = JSON.stringify(params)
  const [data, setData] = useState<PricePreviewResponse | null>(null)

  const stable = useMemo(() => JSON.parse(key) as PricePreviewRequest, [key])

  useEffect(() => {
    let alive = true
    api
      .pricePreview(stable)
      .then((d) => {
        if (alive) setData(d)
      })
      .catch(() => {
        if (alive) setData(null)
      })
    return () => {
      alive = false
    }
  }, [stable])

  return data
}
